import React, { useState } from 'react';

import {
  ActionIcon,
  Button,
  Group,
  MultiSelect,
  Space,
  TextInput,
  Title,
  useMantineTheme,
} from '@mantine/core';
import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { IconPlus, IconSearch, IconX } from '@tabler/icons-react';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';

import DiscountsTableContainer from './components/DiscountsTableContainer';
import DrawerDiscountForm from './components/DrawerDiscountForm';

const Discounts = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();
  const discountPerm = hasPerm('DiscountMutate');

  const [isCreateFormOpened, { open: openCreateForm, close: closeCreateForm }] = useDisclosure(false);

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 250);
  const [statuses, setStatuses] = useState<string[]>(['active', 'inactive']);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearchTerm(value);
  };

  const handleClearSearch = (): void => {
    setSearchTerm('');
  };

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Discounts
          </Title>
          <Group>
            <TextInput
              icon={<IconSearch size={theme.fontSizes.md} />}
              placeholder='Search by name or code'
              value={searchTerm}
              onChange={handleSearchChange}
              rightSection={
                !!searchTerm ? (
                  <ActionIcon onClick={handleClearSearch} size='md'>
                    <IconX size={theme.fontSizes.md} />
                  </ActionIcon>
                ) : (
                  <Space />
                )
              }
            />
            <MultiSelect
              value={statuses}
              onChange={setStatuses}
              placeholder='Select Status'
              clearable
              miw={250}
              data={[
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
                { value: 'archived', label: 'Archived' },
              ]}
            />
            <Button
              leftIcon={<IconPlus size={theme.fontSizes.md} />}
              onClick={openCreateForm}
              disabled={!discountPerm}
            >
              Discount
            </Button>
          </Group>
        </Group>
      </PageHeader>
      <DiscountsTableContainer
        searchTerm={debouncedSearchTerm}
        statuses={statuses}
        permission={discountPerm}
      />
      <DrawerDiscountForm
        type='create'
        formId='create-discount-form'
        opened={isCreateFormOpened}
        closeHandler={closeCreateForm}
        title={<Title order={3}>Create Discount</Title>}
      />
    </>
  );
};

export default Discounts;
